import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import ClientDetailsContainer from "@legacy/clients/ClientDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { CLIENTS_ROUTES } from "@routes/clients"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function ClientDetails() {
    const isDesktop = useIsDesktop()

    const [listRoute] = useSlugExtractor([CLIENTS_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("clients_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined

    return (
        <AppFrame.Root pageId="ClientDetails">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            iconOnly={!isDesktop}
                            label="Clients"
                            icon={icon({ name: "user-circle", style: "regular", family: "sharp" })}
                            iconActive={icon({ name: "user-circle", style: "solid", family: "sharp" })}
                            destination={backDestination}
                        />
                        <TopBar.VerticalDivider />
                        <TopBar.PageSubtitle label="Client Details" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <ClientDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
